// The season's wild cards (Season planning): four checks Scott turns on for
// the season, kept in its notes as `wildCards` (ids).
export const WILD_CARDS = [
  { id: 'money', label: 'Money' },
  { id: 'childcare', label: 'Childcare and camps' },
  { id: 'travel', label: 'Travel' },
  { id: 'house', label: 'The house' },
] as const
